import memoize from 'transmute/memoize';
import FormattedMessage from 'I18n/components/FormattedMessage';
import uniqueIdForObject from 'automation-ui-core/utils/uniqueIdForObject';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import { SupportLinkKeys } from 'automation-ui-usage-tracking/SupportLinks';
import TimeRangePicker from 'automation-ui-canvas/components/settings/TimeRangePicker';
import DocButton from 'automation-ui-usage-tracking/components/DocButton';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { AddIcon } from 'foundations-assets';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TimingManagement = ({
  specificTimesToggled,
  handleSpecificTimesRadioToggled,
  handleAnytimeRadioToggled,
  readOnly,
  flow,
  stagedTimeWindowMetadata,
  onUpdateStagedTimeWindowMetadata,
  use = 'default'
}) => {
  if (!flow) {
    return null;
  }
  const shouldDisplayTimeWindow = memoize(actions => !!actions.toSeq().filter(action => action.getActionType() === ActionTypes.DELAY).filter(action => {
    const timeDelay = action.getMetadata().delay;
    return !timeDelay.daysOfWeek.isEmpty() || !!timeDelay.timeOfDay;
  }).first(), actions => `${uniqueIdForObject(actions)}`);
  const handleAddTimeRange = () => {
    const updatedStagedTimeWindowMetadata = stagedTimeWindowMetadata.addTimeRange();
    onUpdateStagedTimeWindowMetadata(updatedStagedTimeWindowMetadata);
  };
  const shouldHideAlert = readOnly || !specificTimesToggled || !shouldDisplayTimeWindow(flow.getActions());
  const timeRanges = stagedTimeWindowMetadata.getTimeRanges();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      "data-test-id": "platform-settings-timing-options",
      children: /*#__PURE__*/_jsx(ToggleGroup, {
        name: "time-settings-selector",
        children: /*#__PURE__*/_jsx(Tooltip, {
          placement: "left top",
          disabled: !flow.hasEnrollmentSchedule(),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformSettings.timing.scheduleTooltip"
          }),
          children: /*#__PURE__*/_jsx(Toggle, {
            disabled: flow.hasEnrollmentSchedule(),
            checked: specificTimesToggled,
            onChange: ({
              target: {
                checked
              }
            }) => {
              if (checked) handleSpecificTimesRadioToggled();else handleAnytimeRadioToggled();
            },
            readOnly: readOnly
          })
        })
      })
    }), !shouldHideAlert && /*#__PURE__*/_jsxs(Alert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformSettings.timing.delayActionTimeWindowWarning.heading"
      }),
      type: "warning",
      marginBlock: "400",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformSettings.timing.delayActionTimeWindowWarning.content"
      }), ' ', /*#__PURE__*/_jsx(DocButton, {
        supportKey: SupportLinkKeys.LEARN_MORE_ABOUT_TIME_DELAYS_AND_TIMING_WINDOWS,
        use: "link-on-bright",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformSettings.timing.delayActionTimeWindowWarning.button"
        })
      })]
    }), specificTimesToggled && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(List, {
        marginBlockStart: "200",
        children: timeRanges.map((_, index) => /*#__PURE__*/_jsx(ListItem, {
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(TimeRangePicker, {
            use: use,
            index: index,
            stagedTimeWindowMetadata: stagedTimeWindowMetadata,
            onUpdateStagedTimeWindowMetadata: onUpdateStagedTimeWindowMetadata,
            readOnly: readOnly
          })
        }, index))
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.readOnlyTooltip"
        }),
        placement: "right",
        disabled: !readOnly,
        children: /*#__PURE__*/_jsx(Button, {
          "data-test-id": "platform-settings-add-hours",
          use: "link",
          onClick: handleAddTimeRange,
          disabled: readOnly,
          children: /*#__PURE__*/_jsxs(TFlex, {
            wrap: "nowrap",
            align: "center",
            justify: "center",
            gap: 7,
            children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "platformSettings.timing.addHoursLabel"
            })]
          })
        })
      })]
    })]
  });
};
export default TimingManagement;